<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="tech-offer-side flex flex-col items-center" v-if="consultant">
        <h3>We decided to make you an offer!</h3>
        <img src="@/assets/image/consultant_offer.png" alt="interview" />
        <div class="tech-offer-steps">
          <div class="flex">
            <div class="tech-step-order">
              <span>1</span>
            </div>
            <div class="tech-step-info flex-1">Sign up for interview</div>
          </div>
          <div class="flex active">
            <div class="tech-step-order">
              <span>2</span>
            </div>
            <div class="tech-step-info flex-1">We make your a offer</div>
          </div>
          <div class="flex">
            <div class="tech-step-order">
              <span>3</span>
            </div>
            <div
              class="tech-step-info flex-1"
            >You can accept offer to be a active consultant with us!</div>
          </div>
        </div>
      </div>
      <div class="tech-offer-main flex-1">
        <h3>Here's your offer to work for us!</h3>
        <p>
          You have been offered a contract to work with ScaleDesk at the rate of
          <span
            class="strong"
          >${{rate}}/hour</span>. Please sign below, and we'll onboard you when you are done.
        </p>
        <p>
          <span class="strong">Name:</span>
        </p>
        <div class="form-inline">
          <div>
            <input v-model="name" type="text" />
          </div>
        </div>
        <p>
          <span
            class="strong"
          >address (This is the official address we will place for you when dispatching jobs so please use your home address):</span>
        </p>
        <div class="form-inline">
          <div>
            <input v-model="address" type="text" />
          </div>
        </div>
        <div class="form-inline tech-offer-btn">
          <!-- <button class="submit primary" @click="initHelloSign">SIGN</button> -->
          <spinnerButton
            class="submit primary"
            :loading="submitLoading"
            @click.native="initHelloSign"
          >SIGN</spinnerButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as firebase from "@/vendor/firebase";
import { httpGet } from "@/http/http";
import HelloSign from "hellosign-embedded";
import * as config from "@/config";
import * as utils from "@/utils/utils";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  data() {
    return {
      consultant: null,
      rate: 0,
      name: null,
      address: null,
      submitLoading: false
    };
  },
  components: {
    spinnerButton
  },
  computed: {
    ...mapState(["user"])
  },
  watch: {
    user: function() {
      this.initData();
    },
    consultant: function() {
      this.updateConsultant();
    }
  },
  mounted: function() {
    this.$store.commit("closeSidebar");
    this.initData();
  },
  methods: {
    initData: function() {
      if (this.user.consultant && this.user.consultant.id) {
        this.$bind(
          "consultant",
          firebase.db.collection("consultants").doc(this.user.consultant.id)
        );
      }
    },
    updateConsultant: function() {
      if (this.consultant.is_active) {
        this.$router
          .push("/home/consultant/consultant_dashboard?id=" + this.user.consultant.id)
          .catch(err => {});
      }
      if (this.consultant.name) {
        this.name = this.consultant.name;
      } else if (this.user.displayName) {
        this.name = this.user.displayName;
      } else {
        this.name = utils.getNameByEmail(this.consultant.email);
      }
      if (this.consultant.address) this.address = this.consultant.address;
      this.rate = this.consultant.rate ? this.consultant.rate : 0;
    },
    initHelloSign: function() {
      const email = this.consultant.email;
      if (!email) {
        this.$toasted.global.toast_error({
          message: "no email"
        });
        return;
      }
      if (!this.name) {
        this.$toasted.global.toast_error({
          message: "please input your name"
        });
        return;
      }
      if (!this.address) {
        this.$toasted.global.toast_error({
          message: "please input your address"
        });
        return;
      }
      this.submitLoading = true;
      httpGet("get_hellosign_url", {
        email: email,
        name: this.name,
        address: this.address,
        id: this.consultant.id
      }).then(response => {
        if (response.ok) {
          const signUrl = response.data;
          const client = new HelloSign();
          client.on("decline", data => {
            this.submitLoading = false;
          });
          client.on("finish", data => {
            this.submitLoading = false;
            this.$toasted.global.toast_success({
              message:
                "success"
            });
          });
          client.on("close", data => {
            this.submitLoading = false;
          });
          client.on("cancel", () => {
            this.submitLoading = false;
          });
          client.on("error", () => {
            this.$toasted.global.toast_error({
              message: "hellosign error"
            });
            this.submitLoading = false;
          });
          client.open(signUrl, {
            clientId: config.HEELOSIGN_CLIENT_ID
          });
        }
      });
    }
  }
};
</script>
